export default __webpack_public_path__ + "static/media/ic_usdm_40.6f901476.svg";